import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import LocalizationContext from "../../../providers/localization/LocalizationContext";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import CreateShiftComponent from "../list/form/create_shift.component";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import routes from "../../../routes/Routes";

const CreateShiftPage: FC<{}> = () => {
    const { i18n } = useContext(LocalizationContext);
    const navigate = useNavigate();

    const handleOnCreated = (shift: ShiftEntity) => {
        navigate(routes.shift_list.relativePath);
    };

    return (
        <LayoutComponent title={i18n("Crear Turno")}>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="mb-0">{i18n("Nuevo Turno")}</h4>
                            </div>
                            <div className="card-body">
                                <CreateShiftComponent onCreated={handleOnCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    );
};

export default CreateShiftPage;